<template>
  <div class="background">
    <navbar></navbar>
    <div v-if="!isLoading && getVerification" class="verification-container">
      <router-view />
    </div>
    <div v-if="gtmLoaded">
      <iframe
        src="https://www.googletagmanager.com/ns.html?id=GTM-KR93HD"
        height="0"
        width="0"
        style="display:none;visibility:hidden"
      ></iframe>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { mapGetters } from "vuex";

import {
  VERIFICATION_SUCCESS,
  VERIFICATION_REQUEST,
  VERIFICATION_METHOD,
} from "@/store/types";

const baseUrl = process.env.VUE_APP_BACKEND_HOST;

export default {
  data() {
    return {
      gtmLoaded: false,
    };
  },
  computed: {
    ...mapGetters(["getVerification", "isLoading", "getVerifyType"]),
  },
  async mounted() {
    const { token, verifyType } = this.$router.currentRoute.params;

    const { method } = this.$router.currentRoute.query;

    if (method) {
      this.$store.commit(VERIFICATION_METHOD, method);
    }
    // Load GTM if verification report type is landlord verification
    if (verifyType.includes("landlord")) {
      (function(w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != "dataLayer" ? "&l=" + l : "";
        j.async = true;
        j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, "script", "dataLayer", "GTM-KR93HD");
      this.gtmLoaded = true;
    }

    try {
      axios.defaults.headers.common["Authorization"] = token;
      this.$store.commit(VERIFICATION_REQUEST);

      const response = await axios.get(
        `${baseUrl}/api/verify/v1/verifications/`
      );

      this.$store.commit(VERIFICATION_SUCCESS, {
        verifyType,
        verification: response.data,
      });

      this.$router.push({
        name: "verify-section1",
        params: { verifyType },
      });
    } catch (err) {
      if (err.response && err.response.data) {
        if (err.response.data.error === "link_expired") {
          this.$router.push({ name: "expired" });
        } else if (err.response.data.error === "link_invalid") {
          this.$router.push({ name: "expired", query: { invalid: true } });
        } else if (err.response.data.error === "already_complete") {
          this.$router.push({
            name: "complete",
            query: { alreadyCompleted: true }
          });
        } else {
          this.$router.push({ name: "not-found" });
        }
      }

      console.log(err);
    }
  },
};
</script>
<style lang="scss" scoped>
.background {
  background-color: white;
  height: auto;
  display: flex;
  justify-content: center;
  flex-direction: column;

  .verification-container {
    height: 100vh;
    h1 {
      text-align: center;
      font-weight: 600;
    }
    .verification-view {
      margin-top: 20px;
      max-width: 1100px;
      border-radius: 10px;
      border: 1px solid #e4e4e4;
      padding: 20px;
      background: #fff;
      padding-bottom: 50px;
      min-height: 500px;
      flex: 1;
    }
  }
}
@media (max-width: 768px) {
  .verification-container {
    width: 100%;

    .verification-view {
      padding: 5px 5px;
    }
  }
}
</style>
